<template lang="pug">
section
  s-page-title(title='Все заказы')
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(v-if='attributes.statuses', xs-6, style='max-width: 50%')
            v-select(
              :items='attributes.statuses',
              :value='dataFilter.status_id',
              @change='setStatus',
              item-value='id',
              item-text='name',
              label='Статус',
              returnObject,
              clearable
            )
    div(class='table-wrap')
      v-data-table(
        :loading='isLoading'
        :headers='headers'
        :items='list'
        :total-items='total'
        :pagination='dataFilter'
        @update:pagination='updatePagination'
      )
        template(slot='items' slot-scope='props')
          tr(class='with-pointer' @click='onEdit(props.item)')
            td {{ props.item.id }}
            td {{ props.item.created_at }}
            td {{ props.item.number_str }}
            td
              | {{ props.item.user_name }}<br> {{ props.item.user_phone }}
            td
              | {{ props.item.sum }}<br> {{ props.item.sum_to_pay }}
            td
              | {{ props.item.discount_percent }}<br> {{ props.item.discount_sum }}
            td {{ props.item.status_name }}
            td
              | {{ props.item.pickup_type_name }}<br> {{ props.item.pickup_name }}
</template>

<script>
import {debounce, get} from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import http from "@/http";

export default {
  data: () => ({
    attributes: {},
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Дата создания',
        align: 'left',
        sortable: true,
        value: 'created_at',
        width: '140px'
      },
      {
        text: 'Номер заказа',
        align: 'left',
        value: 'number_str',
        sortable: true,
        width: '0%'
      },
      {
        text: 'Клиент',
        align: 'left',
        value: 'user_name',
        sortable: false,
        width: '0%'
      },
      {
        text: 'Сумма заказа,\nСумма к оплате',
        align: 'left',
        value: 'sum',
        width: '0%',
        sortable: true,
        class: 'linebreak'
      },
      {
        text: 'Скидка в %,\nСумма скидки',
        align: 'left',
        value: 'discount_sum',
        width: '0%',
        sortable: true,
        class: 'linebreak'
      },
      {
        text: 'Статус',
        align: 'left',
        value: 'status_name',
        width: '0%',
        sortable: false
      },
      {
        text: 'Место получения',
        align: 'left',
        value: 'pickup_type_name',
        width: '20%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'shop/orders',
      itemValue: 'id',
      itemText: 'name'
    }
  }),

  created() {
    this.setDataFilter({ sortBy: 'created_at', descending: true })
    this.fetch()
    this.fetchAttributes()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Shop.Orders.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    setStatus(status) {
      const status_id = get(status, 'id', null)
      this.setDataFilter({ status_id })
      this.fetch()
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/shop/orders/attributes')
        this.attributes = res.data
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки справочников')
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('shop/orders', ['fetchList', 'destroy']),
    ...mapMutations('shop/orders', ['setDataFilter'])
  },

  computed: {
    ...mapState('shop/orders', ['total', 'dataFilter']),
    ...mapGetters('shop/orders', ['list', 'isLoading']),
  }
}
</script>

<style>
.table-wrap .v-datatable thead th.linebreak {
  white-space: pre;
}

.table-wrap .v-datatable thead th,
.table-wrap .v-datatable tbody td {
  padding: 0 16px !important;
}
</style>
